<template>
  <div class="occupancy">
    <div class="occupancy__items">
      <div class="occupancy__items-row">
        <div class="text-center d-flex">
          <div class="occupancy__title">Adulti</div>
          <div class="occupancy__content">
            <vb-icon
              :name="'minus-circle'"
              :size="20"
              :color="sass(adults > 1 ? 'primary' : 'vb-disabled')"
              :icon_style="{
                '--color': sass(adults > 1 ? 'primary' : 'vb-disabled'),
              }"
              @click.stop="remove_adult"
            />
            <div class="occupancy__qty">{{ adults }}</div>
            <vb-icon
              :name="'plus-circle'"
              :size="20"
              :color="sass(adults < max_adults ? 'primary' : 'vb-disabled')"
              :icon_style="{
                '--color': sass(
                  adults < max_adults ? 'primary' : 'vb-disabled',
                ),
              }"
              @click.stop="add_adult"
            />
          </div>
        </div>

        <div class="text-center d-flex">
          <div class="occupancy__title">Bambini</div>
          <div class="occupancy__content">
            <vb-icon
              :name="'minus-circle'"
              :size="20"
              :color="sass(children.length > 0 ? 'primary' : 'vb-disabled')"
              :icon_style="{
                '--color': sass(
                  children.length > 0 ? 'primary' : 'vb-disabled',
                ),
              }"
              @click.stop="remove_child"
            />
            <div class="occupancy__qty">{{ children.length }}</div>
            <vb-icon
              :name="'plus-circle'"
              :size="20"
              :color="
                sass(children.length < max_children ? 'primary' : 'vb-disabled')
              "
              :icon_style="{
                '--color': sass(
                  children.length < max_children ? 'primary' : 'vb-disabled',
                ),
              }"
              @click.stop="add_child"
            />
          </div>
        </div>
      </div>
      <b-row v-if="children.length">
        <b-col cols="12" class="occupancy__children-disclaimer">
          L'età dei passeggeri viene calcolata alla data dell'ultimo volo del
          viaggio.
        </b-col>
        <b-col
          cols="3"
          lg="6"
          v-for="(m, index) in children"
          v-bind:key="index"
        >
          <vb-select
            class="occupancy__age occupancy__age--desktop"
            @change="
              (value) => {
                set_child_age(value, index);
              }
            "
            :vb_options="{
              options: options,
              value: m,
            }"
          />
          <vb-select
            class="occupancy__age occupancy__age--mobile"
            @change="
              (value) => {
                set_child_age(value, index);
              }
            "
            :vb_options="{
              options: options.map((o) => {
                return { value: o.value, text: o.value };
              }),
              value: m,
              size: 'sm',
            }"
          />
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col>
        <vb-button
          :vb_options="{
            text: `<span class='semibold'>Fatto</span>`,
            variant: 'info',
            size: 'sm',
            block: true,
          }"
          @click="close"
        >
        </vb-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    max_children: Number,
    max_adults: Number,
  },
  data() {
    return {
      adults: this.$store.state.liveflight.adults, //this.$store.state.liveflight.travelers.filter( function(t) { return t.travelerType == 'ADULT' } ).length,
      children: this.$store.state.liveflight.children, //this.$store.state.liveflight.travelers.filter( function(t) { return t.travelerType == 'SEATED_INFANT' } ),
      options: Array.from({ length: 17 }).map((_, index) => {
        const age = 16 - index;
        return { value: age, text: `${age} ann${age !== 1 ? "i" : "o"}` };
      }),
    };
  },
  methods: {
    close() {
      this.$emit("close", {});
    },
    updated() {
      this.$emit("updated", {
        adults: this.adults,
        children: this.children,
      });
    },
    add_child() {
      if (this.children.length >= this.max_children) {
        return;
      }

      let children = this.children;
      children.push(11); // CHILD < 12y
      this.updated();
    },
    remove_child(index) {
      if (this.children.length > 0) {
        let children = this.children;
        children.splice(index, 1);
      }
      this.updated();
    },
    remove_child_by_index(index) {
      let children = this.children;
      children.splice(index, 1);
      this.updated();
    },
    set_child_age(value, index) {
      let children = this.children;
      children[index] = value;
      this.updated();
    },
    add_adult() {
      this.adults = Math.min(this.adults + 1, this.max_adults);
      this.updated();
    },
    remove_adult() {
      this.adults = Math.max(this.adults - 1, 1);
      this.updated();
    },
  },
};
</script>

<style lang="scss">
.occupancy {
  @extend .panel !optional;
  min-width: 100%;
  @include media-breakpoint-up(lg) {
    min-width: 350px;
  }

  display: flex;
  flex-direction: column;
  gap: $grid-gutter-width / 2;
  padding: $grid-gutter-width / 2;
  box-shadow: 0px 0.5rem 1rem 0px rgb(0 11 38 / 24%);

  &__items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    &-row {
      display: flex;
      gap: 20px;
    }
  }

  &__content {
    display: flex;
    align-items: center;
    margin-left: $grid-gutter-width/4;
    svg {
      cursor: pointer;
    }
    .square-icon {
      padding: 3px 6px;
    }
  }

  &__qty {
    white-space: nowrap;
    padding: 0 0.5em;
    font-weight: $vb-font-weight-semibold;
  }
  &__item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: $grid-gutter-width/4;
  }
  &__children {
    // @extend .occupancy--item;
    margin-bottom: $grid-gutter-width/2;
  }
  &__children-disclaimer {
    font-size: $font-size-sm;
    margin-bottom: $grid-gutter-width/4;
  }

  &--done {
    border-top: 1px solid $light-gray;
    padding-top: $grid-gutter-width / 2;
  }

  &__age {
    margin-top: $grid-gutter-width/4;

    @include media-breakpoint-up(lg) {
      & > *:nth-child(even) {
        padding-left: $grid-gutter-width/4;
      }
      & > *:nth-child(odd) {
        padding-right: $grid-gutter-width/4;
      }
      .vb-select {
        margin-top: $grid-gutter-width/2;
      }
    }

    &--desktop {
      @include media-breakpoint-down(md) {
        display: none !important;
      }
    }
    &--mobile {
      display: none !important;
      @include media-breakpoint-down(md) {
        display: block !important;
      }
    }
  }
}
</style>
